import { Close } from '@mui/icons-material';
import { IconButton, Option, Select, SelectStaticProps } from '@mui/joy';
import { useRef } from 'react';

import { Color, Variant } from 'theme/enums';

import { IProps } from './Select';

export const SelectView = ({
  name,
  value,
  options,
  defaultValue,
  placeholder = '',
  multiple = false,
  size,
  disabled = false,
  clearable = false,
  onChange,
  getLabel,
  wrapperStyle,
}: IProps) => {
  const action: SelectStaticProps['action'] = useRef(null);

  return (
    <Select
      name={name}
      value={value}
      defaultValue={defaultValue}
      placeholder={placeholder}
      multiple={multiple}
      size={size}
      disabled={disabled}
      onChange={onChange}
      action={action}
      sx={wrapperStyle}
      {...(clearable &&
        (multiple ? value.length > 0 : value) && {
          endDecorator: (
            <IconButton
              variant={Variant.PLAIN}
              color={Color.NEUTRAL}
              onMouseDown={(event) => {
                // don't open the popup when clicking on this button
                event.stopPropagation();
              }}
              onClick={() => {
                onChange(multiple ? [] : null);
                action.current?.focusVisible();
              }}
            >
              <Close />
            </IconButton>
          ),
          indicator: null,
        })}
    >
      {options?.map((option) => {
        if (option?.hide && option?.value !== value) {
          return;
        }

        return (
          <Option key={option?.value} value={option?.value} disabled={option?.disabled}>
            {getLabel(option)}
          </Option>
        );
      })}
    </Select>
  );
};
